import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Table from "../../components/elements/NewTableList";
import TableDataText from "../../components/elements/TableDataText";
import TableDataSwitch from "../../components/elements/TableDataSwitch";
import classIcon from "../../assets/images/icons/icon_settings_header.svg";
import { getLingoNotifications, putLingoNotification } from "../../store/middleware";

function NotificationsSettings() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [lingoNotifications, setLingoNotifications] = useState([]);

  const notificationsChange = ({ name }, id) => {
    const notification = lingoNotifications.find((notification) => {
      return notification.id === Number(id);
    });

    const { sendToStudent, sendToTeacher, sendToCoordinator, sendToCustomerService, sendToCompanyManager, sendToB2B } =
      notification;

    const submitObj = {
      id: Number(id),
      sendToStudent,
      sendToTeacher,
      sendToCoordinator,
      sendToCustomerService,
      sendToCompanyManager,
      sendToB2B,
    };
    submitObj[name] = !submitObj[name];

    dispatch(putLingoNotification(submitObj)).then(() => window.location.reload());
  };

  const listedNotifications = lingoNotifications.map((item) => {
    const module = item[`${t("LANGUAGE_KEY_STRING")}Module`];
    const notification = item[`${t("LANGUAGE_KEY_STRING")}NotificationName`];
    const {
      id,
      sendToStudent,
      sendToTeacher,
      sendToCoordinator,
      sendToCustomerService,
      sendToCompanyManager,
      sendToB2B,
    } = item;
    return {
      id,
      module,
      notification,
      sendToStudent,
      sendToTeacher,
      sendToCoordinator,
      sendToCustomerService,
      sendToCompanyManager,
      sendToB2B,
    };
  });

  useEffect(() => {
    dispatch(getLingoNotifications()).then((res) => setLingoNotifications(res));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view ">
      <SideMenu />
      <section>
        <Header title={t("NOTIFICATIONS")} icon={classIcon} />

        <div className="content">
          <div className="new-view notifications-view">
            <Table listedItems={listedNotifications}>
              <TableDataText label="module" name="module" />
              <TableDataText label="notification" name="notification" />
              <TableDataSwitch label="student" name="sendToStudent" inputChange={notificationsChange} />
              <TableDataSwitch label="teacher" name="sendToTeacher" inputChange={notificationsChange} />
              <TableDataSwitch label="CO" name="sendToCoordinator" inputChange={notificationsChange} />
              <TableDataSwitch label="CS" name="sendToCustomerService" inputChange={notificationsChange} />
              <TableDataSwitch label="CM" name="sendToCompanyManager" inputChange={notificationsChange} />
              <TableDataSwitch label="B2B" name="sendToB2B" inputChange={notificationsChange} />
            </Table>
          </div>

          <Dialog id="dialog-error" open={open} keepMounted onClose={() => setOpen(false)}>
            <DialogTitle id="dialog-error-title">{t("INVALID_FORM_TITLE")}</DialogTitle>
            <DialogContent>
              <DialogContentText id="dialog-error-message">{"error"}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpen(false)} color="primary">
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </section>
    </div>
  );
}

export default NotificationsSettings;
